export default __webpack_public_path__ + "static/media/FG_25.fda52bc2.jpg";